import { AfterViewInit, ChangeDetectionStrategy, Component, TemplateRef, ViewChild, inject } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import Cookies from 'js-cookie';
import { TermsService } from '../../../terms/terms.service';
import { CheckMarkComponent } from '../../../ui-elements/check-mark/check-mark/check-mark.component';
import { SharedModule } from '../../shared.module';

const COOKIE_CONSENT_REJECT_FOR_DAYS = 90; // 3 months
const COOKIE_CONSENT_ACCEPT_FOR_DAYS = 730; // 2 years

const COOKIE_CONSENT_STATE_NONE = 'none'; // default case while no cookie concent status is stored
const COOKIE_CONSENT_STATE_REQUIRED = 'necessary';
const COOKIE_CONSENT_STATE_ALL = 'all';

@Component({
  selector: 'app-consent-modal',
  templateUrl: './consent-modal.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [SharedModule, CheckMarkComponent],
})
export class ConsentModalComponent implements AfterViewInit {
  private translate = inject(TranslateService);
  private termsService = inject(TermsService);
  private modalService = inject(NgbModal);

  public cookieConsentState = COOKIE_CONSENT_STATE_NONE;
  @ViewChild('cookieModal') cookieModal: TemplateRef<NgbModal>;
  public cookiesMust = true;
  public cookiesStatistics = false;
  private readonly cookieName = 'cookie_consent';

  constructor() {
    this.triggerConsentUpdate(true);
    const cookieValue = Cookies.get(this.cookieName);

    if (!cookieValue) {
      this.cookieConsentState = COOKIE_CONSENT_STATE_NONE;
    } else {
      this.cookieConsentState = cookieValue;
    }

    this.triggerConsentUpdate();
  }

  ngAfterViewInit() {
    if (this.cookieConsentState !== COOKIE_CONSENT_STATE_NONE) {
      return;
    }

    // open consent modal only if no consent_cookie was found
    this.modalService.open(this.cookieModal, {
      windowClass: 'cookie-consent-modal',
      size: 'lg',
      backdropClass: 'bg-success',
      centered: true,
      backdrop: 'static',
      keyboard: false,
    });
  }

  onDismiss() {
    this.saveCookies();
    this.modalService.dismissAll();
  }

  onAgree() {
    this.cookiesStatistics = true;
    this.saveCookies();
    this.modalService.dismissAll();
  }

  getCookieConsentLevel() {
    if (this.cookiesStatistics) {
      return COOKIE_CONSENT_STATE_ALL;
    }

    return COOKIE_CONSENT_STATE_REQUIRED;
  }

  saveCookies() {
    const expiration =
      this.getCookieConsentLevel() === COOKIE_CONSENT_STATE_ALL ? COOKIE_CONSENT_ACCEPT_FOR_DAYS : COOKIE_CONSENT_REJECT_FOR_DAYS;
    Cookies.set(this.cookieName, this.getCookieConsentLevel(), { expires: expiration });
    this.cookieConsentState = this.getCookieConsentLevel();
    this.triggerConsentUpdate();
  }

  triggerConsentUpdate(initDefaults = false) {
    window.dataLayer = window.dataLayer || [];

    function gtag() {
      // @ts-expect-error: dataLayer is a GTM global, not declared on Window
      dataLayer.push(arguments);
    }

    // @ts-expect-error: local gtag() declares no params but GTM calls it with three
    gtag('consent', initDefaults ? 'default' : 'update', {
      ad_storage: 'denied',
      analytics_storage: !initDefaults && this.cookieConsentState === COOKIE_CONSENT_STATE_ALL ? 'granted' : 'denied',
      functionality_storage: !initDefaults && this.cookieConsentState !== COOKIE_CONSENT_STATE_NONE ? 'granted' : 'denied',
      personalization_storage: 'denied',
      security_storage: 'denied',
    });
  }

  openTermsModal(event) {
    event.preventDefault();
    this.termsService.openTermsModal('privacy');
  }
}
